import { Injectable } from "@angular/core";
import { UserHttpService } from "@services";
import { AuthService, CurrentUserService } from "@core";
import { BehaviorSubject, catchError, Observable, of, Subscription } from "rxjs";
import { User, UserInfoStatus, UserPointsUpdate } from "@model";
import { isNotNullOrUndefined } from "@helpers";

@Injectable({ providedIn: "root" })
export class UserService {
  private _userSubscription = new Subscription();
  private _user$ = new BehaviorSubject<User | null>(null);
  user$ = this._user$.asObservable();

  loggedInUser$: Observable<User> = this.user$.pipe(isNotNullOrUndefined());

  constructor(
    private _userHttpService: UserHttpService,
    private _currentUserService: CurrentUserService,
    private _authService: AuthService,
  ) {
    this._currentUserService.currentUser$.subscribe((user) => {
      if (user) {
        this._userSubscription = this._userHttpService.loadUser().pipe(
          catchError(() => {
            this._authService.logout()
            return of(null)
          })
        ).subscribe((user) => {
          this._user$.next(user);
        });
      } else {
        this._user$.next(null);
        this._userSubscription.unsubscribe();
      }
    });
  }

  updateUserPoint(userPointsUpdate: UserPointsUpdate): void {
    const user = this._user$.value;
    if (user) {
      const newUser = {
        ...user,
        ...userPointsUpdate,
      };
      this._user$.next(newUser);
    }
  }

  updateUserInfoStatus(infoStatus: UserInfoStatus): void {
    const update = { infoStatus };
    this._userHttpService.updateUser(update).subscribe((user) => {
      this._user$.next(user);
    });
  }

  hastWelcomeStatusInfo(): boolean {
    return !!this._user$.value?.infoStatus?.welcomeInfo;
  }
}
